module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_06.b5d7fe98.png";